import React, {ReactElement} from 'react';
import {bindActionCreators, Dispatch} from 'redux';
import {connect} from 'react-redux';
import {
  Bold,
  Text,
  MaskTypes,
  Br,
} from '@vizir-banking/banking-app-core/dist/layout';
import {Types} from '@vizir-banking/banking-app-core/dist/layout/navbar/types';
import {SchemaNames} from '@vizir-banking/banking-app-core/dist/common/single-input-form/types';
import {addCreationUser} from '@vizir-banking/banking-app-core/dist/redux/onboarding/add-creation-user';
import {User} from '@vizir-banking/banking-app-core/dist/redux/user/types';

import {ONBOARDING_SCREENS} from '~/navigation/screen-definitions';
import translate from '~/i18n/translate';
import SingleInputForm from '~/onboarding/components/single-input-form/single-input-form';
import {
  OnboardingNavigationProps,
  withOnboardingNavigation,
} from '~/onboarding/navigation/with-onboarding-navigation';
import {OnboardingScreen} from '~/onboarding/components/screen-with-onboarding-progress/screen-with-onboarding-progress';

const actionCreators = {addCreationUser};

type Actions = {
  addCreationUser: (fieldName: keyof User, value: string) => void;
};

const mapDispatchToProps = (dispatch: Dispatch): {actions: Actions} => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

type Props = ReturnType<typeof mapDispatchToProps> & OnboardingNavigationProps;

class PhoneNumberScreen extends React.PureComponent<Props> {
  submit = async (value: string): Promise<void> => {
    const {navigateToNextOnboardingScreen, actions} = this.props;

    actions.addCreationUser('phone', value);
    navigateToNextOnboardingScreen();
  };

  renderText(): ReactElement {
    return (
      <>
        <Text>{translate('onboarding.letsStart')}</Text>
        <Br />
        <Text>
          {translate('onboarding.WhatsYour')}
          <Bold>{translate('onboarding.phoneNumber')}</Bold>?
        </Text>
      </>
    );
  }

  render(): ReactElement {
    return (
      <OnboardingScreen navType={Types.BASIC} showProgress>
        <SingleInputForm
          validationSchemaName={SchemaNames.PHONE}
          content={this.renderText}
          reduxValueKey="phone"
          textInputMask={MaskTypes.PHONE}
          onSubmit={this.submit}
        />
      </OnboardingScreen>
    );
  }
}

export default connect(
  null,
  mapDispatchToProps,
)(withOnboardingNavigation(PhoneNumberScreen, ONBOARDING_SCREENS.phoneNumber));
